import { render, staticRenderFns } from "./AlarmMessage.vue?vue&type=template&id=97996a16&scoped=true"
import script from "./AlarmMessage.vue?vue&type=script&lang=js"
export * from "./AlarmMessage.vue?vue&type=script&lang=js"
import style0 from "./AlarmMessage.vue?vue&type=style&index=0&id=97996a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97996a16",
  null
  
)

export default component.exports